import { call, put, takeLatest } from "redux-saga/effects";

import {
  setReports,
  FETCH_REPORTS_INFO,
} from "../actions/reports.actions";
import { reportsApi, Report } from "../../api";

const api = {
  getReports: (...args: Parameters<typeof reportsApi.getReports>) =>
    reportsApi.getReports(...args),
}

function* fetchReports() {
  try {
    // Request
    const { data } = yield call(api.getReports);
    // Store data
    yield put(setReports(data as Report[]));
  } catch (e) {
    // Denote error
    // TODO
  }
}

function* reportsSaga() {
  yield takeLatest(FETCH_REPORTS_INFO, fetchReports);
}

export default reportsSaga;
